import { isParent } from './isParent';

export function removeParents(tagFullPaths: string[]): string[] {
  const bottomLevelTags: string[] = [];

  tagFullPaths.forEach((current) => {
    let isCurrentParent = false;
    tagFullPaths.forEach((potentialChild) => {
      isCurrentParent = isCurrentParent || isParent(current, potentialChild);
    });
    if (!isCurrentParent) bottomLevelTags.push(current);
  });

  return bottomLevelTags;
}
